import ajax from './http'

// 修改密码
export const changePassword = (params) => ajax('post', '/api/user/change_password', params);
// 用户列表
export const getUserList = (params) => ajax('post', '/api/user', params);
// 编辑用户
export const editUserInfo = (params) => ajax('post', '/api/user/edit', params);
// 发送重置链接
export const sendUrl = (params) => ajax('post', 'api/auth/reset_url', params);
// 重置密码
export const resetPsd = (params) => ajax('post', 'api/auth/reset_password', params);
// 查询应用列表
export const appManagementGetList = (params) => ajax('post', 'api/application/get_list', params);
// 新增应用
export const appManagementAdd = (params) => ajax('post', 'api/application/create', params);
// 编辑、删除应用
export const appManagementEdit = (params) => ajax('post', 'api/application/edit', params);
// 查询用户是否是sso管理员
export const hasSsoAdmin = (params) => ajax('post', 'api/user/hasSsoAdmin', params);

// 上传图片
export const uploadFile = (params) => ajax('post', 'api/common/upload_file', params);
// 获取图片和背景色配置
export const getSsoConfig = (params) => ajax('post', 'api/common/get_sso_config', params);
// 保存图片和背景色配置
export const saveSsoConfig = (params) => ajax('post', 'api/common/save_sso_config', params);







// WEBPACK FOOTER //
// ./src/assets/js/apiUse/publicApi.js